import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

/**
 * Export table data to a styled PDF
 * @param {string} title - Report title
 * @param {string[]} columns - Column headers
 * @param {string[][]} rows - Table row data (array of arrays)
 * @param {string} filename - Output filename
 * @param {object} [meta] - Optional metadata (date range, filters, summary stats)
 */
export function exportTableToPdf(title, columns, rows, filename, meta = {}) {
  const doc = new jsPDF({ orientation: rows[0]?.length > 6 ? 'landscape' : 'portrait' });

  // Dark header bar
  doc.setFillColor(0, 11, 24);
  doc.rect(0, 0, doc.internal.pageSize.width, 32, 'F');

  // Title
  doc.setTextColor(0, 229, 255);
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text(title, 14, 16);

  // Subtitle line
  doc.setFontSize(9);
  doc.setTextColor(160, 180, 204);
  const dateStr = new Date().toLocaleDateString('en-PH', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  let subtitle = `Generated: ${dateStr}`;
  if (meta.dateFrom || meta.dateTo) {
    subtitle += `  |  Range: ${meta.dateFrom || 'start'} to ${meta.dateTo || 'now'}`;
  }
  if (meta.filters) subtitle += `  |  ${meta.filters}`;
  doc.text(subtitle, 14, 26);

  let startY = 38;

  // Summary stats if provided
  if (meta.stats && meta.stats.length > 0) {
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);
    meta.stats.forEach((stat, i) => {
      doc.setFont('helvetica', 'normal');
      doc.text(`${stat.label}: `, 14 + (i % 3) * 65, startY + Math.floor(i / 3) * 7);
      doc.setFont('helvetica', 'bold');
      doc.text(`${stat.value}`, 14 + (i % 3) * 65 + doc.getTextWidth(`${stat.label}: `), startY + Math.floor(i / 3) * 7);
    });
    startY += Math.ceil(meta.stats.length / 3) * 7 + 4;
  }

  // Table
  autoTable(doc, {
    head: [columns],
    body: rows,
    startY,
    theme: 'grid',
    headStyles: {
      fillColor: [4, 26, 59],
      textColor: [0, 229, 255],
      fontStyle: 'bold',
      fontSize: 8,
      halign: 'left',
    },
    bodyStyles: {
      fontSize: 7.5,
      textColor: [30, 30, 30],
      cellPadding: 3,
    },
    alternateRowStyles: {
      fillColor: [240, 245, 250],
    },
    styles: {
      lineColor: [200, 210, 220],
      lineWidth: 0.3,
      overflow: 'linebreak',
    },
    margin: { top: 10, left: 14, right: 14 },
    didDrawPage: (data) => {
      // Footer
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFontSize(7);
      doc.setTextColor(150, 150, 150);
      doc.text(
        `All Global Access - ${title} | Page ${data.pageNumber} of ${pageCount}`,
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 8,
        { align: 'center' }
      );
    },
  });

  doc.save(filename);
}
